import { useGeoIP } from '@hc-frontend/core-ui';

export interface UnstyledStateTextProps {
  content: string;
  accentColor: string;
  fallbackState: string;
}

export default function UnstyledStateText(props: UnstyledStateTextProps) {
  const location = useGeoIP();
  let outputString: string;

  // Step 1: Replace {{state}} in source string with either the user's IP state or a default fill-in
  if (location) {
    outputString = props.content.replace('{{state}}', location.state);
  } else {
    outputString = props.content.replace('{{state}}', props.fallbackState);
  }

  // Step 2: Divide the string at the '^' character into unaccented and accented text
  const dividedString = outputString.split('^');

  // Step 3: Return a formatted string
  return (
    <div className="[all: inherit]">
      {dividedString[0]}
      {dividedString[1] && (
        <span
          style={{
            color: props.accentColor,
          }}
        >
          {dividedString[1]}
        </span>
      )}
    </div>
  );
}
